import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subscription, of, BehaviorSubject } from 'rxjs';
import { Store } from '@ngrx/store';
import { AmpFlowComponent } from '../base-components/amp-flow/amp-flow.component';
import { IndexedDbService, getActiveManifestItem, ModalService, ManifestController, BigFormService } from '@flexus/core';
import { AmpWorkflowShellComponent } from '../base-components/amp-workflow-shell/amp-workflow-shell.component';
import { take } from 'rxjs/operators';

@Injectable()
export class DeactivateStateGuard implements OnDestroy, CanDeactivate<AmpFlowComponent | AmpWorkflowShellComponent> {
	canGo$ = new BehaviorSubject(false);
	canDiscard: boolean;
	manifestItem;
	manifestItemSub: Subscription;
	constructor(
		public indexedDbService: IndexedDbService,
		private controller: ManifestController<any>,
		public store: Store<any>,
		public modalService: ModalService,
		public bf: BigFormService,
		public router: Router
	) {
		this.manifestItemSub = this.controller
			.select(getActiveManifestItem)
			.pipe(take(1))
			.subscribe(item => (this.manifestItem = item));
	}

	canDeactivate(
		component: AmpFlowComponent,
		currentRoute: ActivatedRouteSnapshot,
		currentState: RouterStateSnapshot,
		nextState: RouterStateSnapshot
	): Observable<boolean> | boolean | Promise<boolean> {
		if (this.manifestItem.deactivateStateGuard) {
			return this.manifestItem.deactivateStateGuard(this, component, this.router, currentRoute, currentState, nextState);
			//  return this.canGo.asObservable();
		} else {
			return of(true);
		}
	}

	resetCanGoVariable() {
		this.canGo$.next(false);
	}

	ngOnDestroy() {
		if (this.manifestItemSub) this.manifestItemSub.unsubscribe();
	}
}
